import { driverApi } from "./driver.api";

export const {
  useListDriversInfiniteQuery,
  useLazySearchDriversQuery,
  useGetDriversQuery,
  useGetDriverQuery,
  useLazyGetDriverQuery,
  useGetDriversGroupQuery,
  useLazyGetDriversGroupQuery,
  useDeleteDriverMutation,
  useEditDriverMutation,
  useUnbindDriverShippingCompanyMutation,
  useListDriversGroupInfiniteQuery
} = driverApi;
